import styled from 'styled-components';
import PropTypes from 'prop-types';

import { buildStyledComponent } from 'decisiv-ui-utils';

const styles = ({ theme }) => `
  position: relative;
  display: flex;
  align-items: center;

  .Dropdown-control .ButtonLink {
    color: ${theme.colors.base.chrome000};
  }

  .Dropdown-option .ButtonLink {
    color: ${theme.colors.base.link};
  }

  .Dropdown-option.is-selected .ButtonLink {
    color: ${theme.colors.base.chrome000};
  }
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      chrome000: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default buildStyledComponent(
  'DropdownWrapper',
  styled.div,
  styles,
  { themePropTypes },
);



// WEBPACK FOOTER //
// ./compositions/EstimateInvoicePendingWidget/DropdownWrapper.js